import React from 'react';

export const Team = () => {
  const achievements = [
    {
      icon: 'fa fa-bar-chart',
      title: 'Custom Real-time Analytics Platform',
      description:
        'Developed an Apache Superset-based platform that significantly reduced BI licensing costs while delivering powerful real-time analytics and dashboards.',
    },
    {
      icon: 'fa fa-database',
      title: 'Building ETL and Data Warehouse',
      description:
        'Designed robust SSIS & SQL pipelines to ingest and clean data into a centralized warehouse, enabling scalable and insightful Power BI reporting.',
    },
    {
      icon: 'fa fa-robot', // or 'fa fa-comment-dots' for chatbot
      title: 'AI/ML Integration – Custom Chatbot',
      description:
        'Integrated a prompt-based custom chatbot on a company website to handle customer interactions, manage complaints efficiently, and drive improvements in customer experience, satisfaction, and sales performance.',
    },
    {
      icon: 'fa fa-graduation-cap',
      title: 'Bespoke Learning Management System',
      description:
        'Built a custom Learning Management System (LMS) for a tech institution, automating student learning, innovation projects, performance tracking, payment processing, and third-party integrations—resulting in significantly higher uptake and outcomes.',
    },
    {
      icon: 'fa fa-line-chart',
      title: 'Finance & Project Performance Dashboard',
      description:
        'Developed a custom finance and project performance dashboard using Power BI, Excel, and SQL database integrations to enhance financial tracking, sales monitoring, and marketing effectiveness.',
    },
    {
      icon: 'fa fa-bell',
      title: 'Operational KPIs Monitoring',
      description:
        'Implemented automated KPI triggers and real-time alerts using Power BI and Apache Superset to enable proactive operational monitoring and decision-making.',
    },
  ];

  return (
    <section
      id="team"
      style={{
        padding: '5rem 0',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative elements */}
      <div
        style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #2563eb20 0%, #7e22ce20 100%)',
          filter: 'blur(40px)',
          zIndex: 0,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          bottom: '-50px',
          left: '-50px',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #2563eb20 0%, #7e22ce20 100%)',
          filter: 'blur(40px)',
          zIndex: 0,
        }}
      ></div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1.5rem',
          textAlign: 'center',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <div style={{ marginBottom: '3rem' }}>
          <h2
            style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              color: '#1e293b',
              marginBottom: '0.75rem',
              position: 'relative',
              display: 'inline-block',
            }}
          >
            What We Have Done
            <span
              style={{
                content: '',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '60px',
                height: '4px',
                background: 'linear-gradient(90deg, #2563eb, #7e22ce)',
                borderRadius: '2px',
              }}
            ></span>
          </h2>
          <p
            style={{
              fontSize: '1.8rem',
              color: '#64748b',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6',
              marginTop: '15px',
              marginBottom: '15px',
            }}
          >
            Some of our key achievements and solutions delivered:
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            margin: '0 auto',
          }}
        >
          {achievements.map((item, idx) => (
            <div
              key={idx}
              style={{
                background: '#fff',
                boxShadow:
                  '0 10px 25px rgba(0,0,0,0.05), 0 5px 10px rgba(0,0,0,0.05)',
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                border: '1px solid rgba(0,0,0,0.03)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow =
                  '0 10px 25px rgba(0,0,0,0.05), 0 5px 10px rgba(0,0,0,0.05)';
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '4px',
                  background: 'linear-gradient(90deg, #2563eb, #7e22ce)',
                }}
              ></div>

              <div
                style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  background:
                    'linear-gradient(135deg, #2563eb20 0%, #7e22ce20 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.5rem',
                  fontSize: '2rem',
                }}
              >
                <i className={item.icon}></i>
              </div>

              <h3
                style={{
                  fontSize: '2.1rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1rem',
                  lineHeight: '1.4',
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  color: '#64748b',
                  fontSize: '1.3rem',
                  lineHeight: '1.6',
                }}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* <div style={{ marginTop: '3rem' }}>
          <button
            style={{
              background: 'linear-gradient(90deg, #2563eb, #7e22ce)',
              color: 'white',
              border: 'none',
              padding: '0.875rem 2rem',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(37, 99, 235, 0.2)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow =
                '0 6px 20px rgba(37, 99, 235, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow =
                '0 4px 15px rgba(37, 99, 235, 0.2)';
            }}
          >
            View All Achievements
          </button>
        </div> */}
      </div>
    </section>
  );
};
